const createEvent = (eventName, eventType, pageUri, attributes = {}) => ({
    event_timestamp: new Date().getTime(),
    event_name: eventName,
    event_type: eventType,
    page_uri: pageUri.substring(0, 99),
    ...(Object.keys(attributes).length && { attributes })
});

const formCustomEvent = (event, eventData, index, data) => {
    let appEvent = [];
    if (event === "action") {
        if ((eventData.questionType === "single" || eventData.questionType === "multi") && eventData.action !== "skip") {
            eventData.answerResponse.forEach((answer) => {
                const option = answer?.tag ? answer.tag : answer.answerText;
                const pageUri = `/quiz/${data.quiz._id}/question/${eventData._id}`;
                const attributes = { option };  // Adding attributes for "answer_tag"
                appEvent.push(createEvent("answer_tag", "selected", pageUri, attributes));
            });
        }

        if (eventData.questionType === "input" && eventData.action !== "skip") {
            let label = "input_submit";
            eventData.answerResponse.forEach((answer) => {
                label = `${label}_${answer.inputLabel.replace(" ", "_")}`;
            });
            const pageUri = `/quiz/${data.quiz._id}/question/${eventData._id}`;
            appEvent.push(createEvent(label, "click", pageUri));
        }

        if (eventData.questionType === "selfie" && eventData.action === "skip") {
            const pageUri = `/quiz/${data.quiz._id}/${eventData.questionType}`;
            appEvent.push(createEvent("continue_without_selfie", "click", pageUri));
        }
    }

    if (event === "pageview" && index == 1) {
        const displayQuestion = data.questionList[index];
        let questionUri = ""
        if (displayQuestion.type === "single" || displayQuestion.type === "multi" || displayQuestion.type === "input") {
            questionUri = `/quiz/${data.quiz._id}/question/${data.questionList[index]._id}`;
        }
        else if (displayQuestion.type === "email") {
            questionUri = `/quiz/${data.quiz._id}/form`;
        } else {
            questionUri = `/quiz/${data.quiz._id}/${displayQuestion.type}`;
        }
        const eventData = { start_quiz: true }
        appEvent.push(createEvent("View", "page_view", questionUri, eventData));
    }
    if (event === "pageview" && index != 1) {
        const displayQuestion = data.questionList[index];
        let questionUri = ""
        if (displayQuestion.type === "single" || displayQuestion.type === "multi" || displayQuestion.type === "input") {
            questionUri = `/quiz/${data.quiz._id}/question/${data.questionList[index]._id}`;
        }
        else if (displayQuestion.type === "email" || displayQuestion.type === "thanks") {
            questionUri = `/quiz/${data.quiz._id}/${displayQuestion.type === "email" ? 'form' : 'summary'}`;
        } else {
            questionUri = `/quiz/${data.quiz._id}/${displayQuestion.type}`;
        }
        appEvent.push(createEvent("View", "page_view", questionUri));
    }
    if (event === "back") {
        let questionUri = '';
        if (data.questionList[index].type === "welcome" || data.questionList[index].type === "selfie") {
            questionUri = `/quiz/${data.quiz._id}/${data.questionList[index].type}`;
        } else {
            questionUri = `/quiz/${data.quiz._id}/question/${data.questionList[index]._id}`;
        }
        appEvent.push(createEvent("back", "click", questionUri, eventData))
    }
    if (event === "take_selfie" || event === "photo_upload") {
        const pageURI = `/quiz/${data.quiz._id}/selfie`
        appEvent.push(createEvent(event, "click", pageURI))
    }
    if (event === "submit_selfie") {
        const pageURI = `/quiz/${data.quiz._id}/selfie-result`
        appEvent.push(createEvent(event, "click", pageURI, eventData))
    }
    if (event === "selfie_response") {
        const pageURI = `/quiz/${data.quiz._id}/selfie-result`
        appEvent.push(createEvent(event, "api", pageURI, eventData))
    }
    return appEvent;
};

export default formCustomEvent;